import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },
  completedIcon: {
    color: theme.palette.success.main,
  },
  completedBar: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.success.main,
    },
  },
}));
